import { Pencil, Trash2 } from 'lucide-react'
import { ShippingLocation_ } from 'src/api/db/apiShippingLocations'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui/button'
import { Badge } from 'src/shared/components/ui/badge'
import { TableCell, TableRow } from 'src/shared/components/ui/table'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { cn } from 'src/shared/components/ui/utils'
import { formatAddress, formatRegion } from './utils'

interface ShippingLocationRowProps {
  location: ShippingLocation_
  onEdit: (location: ShippingLocation_) => void
  onDelete: (id: number) => void
}

export const ShippingLocationRow = ({
  location,
  onEdit,
  onDelete,
}: ShippingLocationRowProps) => {
  const { t } = useLocalization()

  return (
    <TableRow>
      <TableCell>
        <Column className="gap-1">
          <span className="font-medium">
            {location.company_name || location.name || '-'}
          </span>
          {location.default && (
            <Badge
              variant="outline"
              className="w-fit text-xs bg-blue-50 text-blue-700 border-blue-200"
            >
              {t('Default', 'Standard')}
            </Badge>
          )}
        </Column>
      </TableCell>
      <TableCell className="text-gray-600">{formatAddress(location)}</TableCell>
      <TableCell className="text-gray-600">
        {formatRegion(location, t)}
      </TableCell>
      <TableCell>
        <Badge
          variant="outline"
          className={cn(
            'w-fit',
            location.active
              ? 'bg-green-50 text-green-700 border-green-200'
              : 'bg-gray-50 text-gray-600 border-gray-200'
          )}
        >
          {location.active ? t('Active', 'Aktiv') : t('Inactive', 'Inaktiv')}
        </Badge>
      </TableCell>
      <TableCell>
        <Row className="gap-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onEdit(location)}
            className="h-8 w-8 p-0 hover:bg-gray-100"
          >
            <Pencil className="h-4 w-4 text-gray-600" />
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onDelete(location.id)}
            className="h-8 w-8 p-0 hover:bg-gray-100"
          >
            <Trash2 className="h-4 w-4 text-gray-600" />
          </Button>
        </Row>
      </TableCell>
    </TableRow>
  )
}
